import '../styles/food-search-sheet.css';
import { type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { useSheet, type DismissReason } from './useSheet';

/** The routed diary remains mounted behind this modal; shared owner handles viewport and focus. */
export function FoodSearchSheet({ children, onClose, returnLabel }: {
  children: (dismiss: () => void) => ReactNode; onClose: () => void; returnLabel: string;
}) {
  const { panel, requestDismiss } = useSheet(onClose, { returnFocus: () => {
    const background = document.querySelector<HTMLElement>('[data-food-background]');
    [...background?.querySelectorAll<HTMLButtonElement>('button') ?? []].find(button => button.getAttribute('aria-label') === returnLabel)?.focus({ preventScroll: true });
  } });
  const dismiss = (reason: DismissReason = 'cancel') => requestDismiss(reason);
  return createPortal(<div className="app food-search-overlay sheet-layer" onClick={event => { if (event.target === event.currentTarget) dismiss('backdrop'); }}>
    <div className="sheet-motion food-search-motion" data-sheet-motion>
    <div className="food-search-sheet sheet-interactive" ref={panel} role="dialog" aria-modal="true" aria-label="Поиск продукта" tabIndex={-1}>
      <button className="sheet-handle" data-sheet-handle type="button" aria-label="Закрыть поиск" onClick={() => dismiss('handle')}><span aria-hidden="true" /></button>
      {children(() => dismiss())}
    </div>
    </div>
  </div>, document.body);
}
